import FootWrap from './FootWrap';

export default FootWrap;
